var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#F5F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97631 14.3098C7.60143 13.6847 8.44928 13.3335 9.33333 13.3335H14.6667C15.5507 13.3335 16.3986 13.6847 17.0237 14.3098C17.6488 14.9349 18 15.7828 18 16.6668V18.0002C18 18.3684 17.7015 18.6668 17.3333 18.6668C16.9651 18.6668 16.6667 18.3684 16.6667 18.0002V16.6668C16.6667 16.1364 16.456 15.6277 16.0809 15.2526C15.7058 14.8775 15.1971 14.6668 14.6667 14.6668H9.33333C8.8029 14.6668 8.29419 14.8775 7.91912 15.2526C7.54405 15.6277 7.33333 16.1364 7.33333 16.6668V18.0002C7.33333 18.3684 7.03486 18.6668 6.66667 18.6668C6.29848 18.6668 6 18.3684 6 18.0002V16.6668C6 15.7828 6.35119 14.9349 6.97631 14.3098Z",
    fill: "#E2E7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9974 6.66683C10.8928 6.66683 9.9974 7.56226 9.9974 8.66683C9.9974 9.7714 10.8928 10.6668 11.9974 10.6668C13.102 10.6668 13.9974 9.7714 13.9974 8.66683C13.9974 7.56226 13.102 6.66683 11.9974 6.66683ZM8.66406 8.66683C8.66406 6.82588 10.1564 5.3335 11.9974 5.3335C13.8383 5.3335 15.3307 6.82588 15.3307 8.66683C15.3307 10.5078 13.8383 12.0002 11.9974 12.0002C10.1564 12.0002 8.66406 10.5078 8.66406 8.66683Z",
    fill: "#E2E7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.6a5ff21681d6123b02e97ebc9a1ba9d2.svg";
export { ForwardRef as ReactComponent };